<template>
    <header-helper id="average-ticket">
        <ul>
            <li class="ticket-range-legend">
                <span class="legend-icon-wrapper">
                    <span class="legend-icon"></span>
                </span>
                Ticket Range
            </li>
            <li class="average-ticket-legend">
                <span class="legend-icon-wrapper">
                    <span class="legend-icon"></span>
                </span>
                Average Ticket
            </li>
            <li class="max-ticket-legend">
                <span class="legend-icon-wrapper">
                    <span class="legend-icon"></span>
                </span>
                Top Premium
            </li>
        </ul>
    </header-helper>
</template>

<script>
import HeaderHelper from 'src/components/GrossesHeader/HeaderHelper';

export default {
    components: {
        HeaderHelper,
    },
};
</script>
